export const baseMethods = {
  methods: {
    getPipelineLength(dots, k) {
      var distance = 0;
      for (let key in dots) {
        if (key != 0) {
          distance += this.distanceToPoint(dots[key - 1].x, dots[key - 1].y, dots[key].x, dots[key].y) / parseFloat(k);
        }
        if (dots[key].dots) {
          let child = [{ x: dots[key].x, y: dots[key].y }].concat(dots[key].dots);
          distance += this.getPipelineLength(child, k);
        }
      }
      return Math.round(distance * 100) / 100;
    },
    distanceToPoint(x, y, aX, aY) {
      return Math.sqrt(Math.pow(aX - x, 2) + Math.pow(aY - y, 2));
    },
    getDikinsS(dots, k) {
      var n = dots.length;
      var sum = 0;
      for (let i = 0; i < n; i++) {
        sum += dots[i].x * dots[(i + 1) % n].y - dots[(i + 1) % n].x * dots[i].y;
      }
      var S = Math.abs(sum) / 2 / Math.pow(k, 2);
      return Math.round(S * 100) / 100;
    },
  },
};
